import { Guid } from "@/Common/Models/Guid";

class InboundFaxPageModel {
    public InboundFaxId: Guid | string;
    public PageNumber: number;
    public AssignedToDocumentDate: Date = null;
    public AssignedToDocumentId: Guid = null;
    public LastUpdatedDate: Date = null;
    public LastUpdatedByEmployeeId: Guid = null;
    public DeletedDate: Date = null;
    public DeletedByEmployeeId: Guid = null;
    public Orientation: number = 0;
}

export { InboundFaxPageModel };
